export default `@charset "UTF-8";
/**
 * Checkbox Mixins.
 */
@keyframes check {
  0% {
    height: 0;
    left: 0;
    top: 8px;
    width: 0;
  }
  50% {
    height: 0;
    left: 0;
    top: 8px;
    width: 4px;
  }
  100% {
    height: 10px;
    left: 4px;
    top: 0;
    width: 4px;
  }
}
@keyframes checkindeterminate {
  0% {
    width: 0;
  }
  100% {
    width: 10px;
  }
}
.validation-message {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  margin-top: var(--ids-space-2xs);
  max-width: var(--ids-input-width-full);
}
.validation-message.has-custom-icon {
  color: var(--ids-icon-color-default);
}
.validation-message.disabled {
  color: var(--ids-input-color-text-disabled);
}
.validation-message .ids-icon {
  margin-inline-end: var(--ids-space-2xs);
}
.validation-message.alert {
  color: var(--ids-color-caution-default);
}
.validation-message.alert.disabled {
  color: var(--ids-color-yellow-30);
}
.validation-message.warning {
  color: var(--ids-color-warning-default);
}
.validation-message.warning.disabled {
  color: var(--ids-color-orange-30);
}
.validation-message.error {
  color: var(--ids-color-error-default);
}
.validation-message.error.disabled {
  color: var(--ids-color-red-30);
}
.validation-message.info {
  color: var(--ids-color-info-default);
}
.validation-message.info.disabled {
  color: var(--ids-color-blue-30);
}
.validation-message.success {
  color: var(--ids-color-success-default);
}
.validation-message.success.disabled {
  color: var(--ids-color-green-30);
}
.validation-message[hidden] {
  display: none;
}

:host([suppress-error-message]) .validation-message {
  display: none;
}

:host([label-position=inline-start]) .ids-input,
:host([label-position=inline-start]) .ids-textarea {
  display: flex;
  align-items: var(--ids-label-align-y, center);
}
:host([label-position=inline-start]) .ids-input label,
:host([label-position=inline-start]) .ids-textarea label {
  width: var(--ids-label-width);
  padding-block: var(--ids-label-padding-block);
  padding-inline-end: 0;
  box-sizing: border-box;
  flex-shrink: 0;
}
:host([label-position=inline-start]) .ids-input .validation-message,
:host([label-position=inline-start]) .ids-textarea .validation-message {
  width: 100%;
  margin-block-start: var(--ids-space-2xs);
}
@media (max-width: 927px) {
  :host([label-position=inline-start]) .ids-input .validation-message,
  :host([label-position=inline-start]) .ids-textarea .validation-message {
    margin-inline-start: 0;
  }
}
@media (width > 320px) {
  :host([label-position=inline-start]) .ids-input .ids-label-text,
  :host([label-position=inline-start]) .ids-textarea .ids-label-text {
    margin-inline-end: 0;
  }
}
@container (width > \$breakpoint-xs) {
  :host([label-position=inline-start]) .ids-input .ids-label-text,
  :host([label-position=inline-start]) .ids-textarea .ids-label-text {
    margin-inline-end: 0;
  }
}
@media (min-width: 320px) {
  :host([label-position=inline-start]) .ids-input,
  :host([label-position=inline-start]) .ids-textarea {
    flex-wrap: wrap;
    gap: 8px;
  }
  :host([label-position=inline-start]) .ids-input label,
  :host([label-position=inline-start]) .ids-textarea label {
    flex: 0 0 auto;
    margin-bottom: unset;
    order: 1;
  }
  :host([label-position=inline-start]) .ids-input .field-container,
  :host([label-position=inline-start]) .ids-textarea .field-container {
    order: 2;
  }
  :host([label-position=inline-start]) .ids-input .textarea-field-group,
  :host([label-position=inline-start]) .ids-textarea .textarea-field-group {
    order: 2;
    flex: 1 1 auto;
    min-width: 0;
  }
  :host([label-position=inline-start]) .ids-input .validation-message,
  :host([label-position=inline-start]) .ids-textarea .validation-message {
    flex: 1 1 100%;
    min-width: 100%;
    order: 3;
    margin-block-start: calc(0px - var(--ids-space-2xs));
  }
  :host([label-position=inline-start]) .ids-input.wrapped .validation-message,
  :host([label-position=inline-start]) .ids-textarea.wrapped .validation-message {
    margin-block-start: calc(0px - var(--ids-space-2xs));
    margin-inline-start: calc(var(--ids-label-width) + 6px);
  }
}
:host([label-position=inline-start]) .ids-checkbox {
  margin-top: var(--ids-space-00);
}
@media (min-width: 320px) {
  :host([label-position=inline-start]) .ids-checkbox {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, center);
  }
  :host([label-position=inline-start]) .ids-checkbox label {
    display: flex;
    align-items: center;
    width: 100%;
    padding-block: var(--ids-label-padding-block);
    box-sizing: border-box;
    gap: var(--ids-space-xs);
  }
  :host([label-position=inline-start]) .ids-checkbox .label-checkbox {
    width: var(--ids-label-width);
    flex-shrink: 0;
  }
  :host([label-position=inline-start]) .ids-checkbox .checkbox-wrapper {
    position: relative;
    display: inline-flex;
  }
  :host([label-position=inline-start]) .ids-checkbox .field-container {
    flex: 1;
  }
  :host([label-position=inline-start]) .ids-checkbox .validation-message {
    width: 100%;
    margin-inline-start: calc(var(--ids-label-width) + var(--ids-space-xs));
    margin-block-start: var(--ids-space-2xs);
  }
  :host([label-position=inline-start]) .ids-checkbox.label-state-collapsed .validation-message {
    margin-inline-start: unset;
  }
}
@container (min-width: 320px) {
  :host([label-position=inline-start]) .ids-checkbox {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, center);
  }
  :host([label-position=inline-start]) .ids-checkbox label {
    display: flex;
    align-items: center;
    width: 100%;
    padding-block: var(--ids-label-padding-block);
    box-sizing: border-box;
    gap: var(--ids-space-xs);
  }
  :host([label-position=inline-start]) .ids-checkbox .label-checkbox {
    width: var(--ids-label-width);
    flex-shrink: 0;
  }
  :host([label-position=inline-start]) .ids-checkbox .checkbox-wrapper {
    position: relative;
    display: inline-flex;
  }
  :host([label-position=inline-start]) .ids-checkbox .field-container {
    flex: 1;
  }
  :host([label-position=inline-start]) .ids-checkbox .validation-message {
    width: 100%;
    margin-inline-start: calc(var(--ids-label-width) + var(--ids-space-xs));
    margin-block-start: var(--ids-space-2xs);
  }
}

:host([label-position=inline-start][horizontal-aligned]) .ids-checkbox {
  container-type: normal;
}
@media (width <= 320px) {
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, center);
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox label {
    display: flex;
    align-items: center;
    width: 100%;
    padding-block: var(--ids-label-padding-block);
    padding-inline-end: var(--ids-label-padding-inline-end);
    box-sizing: border-box;
    gap: var(--ids-space-xs);
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox .label-checkbox {
    width: var(--ids-label-width);
    flex-shrink: 0;
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox .checkbox-wrapper {
    position: relative;
    display: inline-flex;
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox .field-container {
    flex: 1;
  }
  :host([label-position=inline-start][horizontal-aligned]) .ids-checkbox .validation-message {
    width: 100%;
    margin-inline-start: calc(var(--ids-label-width) + var(--ids-space-xs));
    margin-block-start: var(--ids-space-2xs);
  }
}

:host([label-position=inline-start][label-alignment=end]) .ids-input,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea {
  gap: var(--ids-label-alignment-gap);
}
:host([label-position=inline-start][label-alignment=end]) .ids-input label,
:host([label-position=inline-start][label-alignment=end]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea label,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea .ids-label-text {
  display: inline-flex;
  align-items: var(--ids-label-align-y, center);
  justify-content: flex-end;
  text-align: end;
  position: relative;
}
@media (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input label,
  :host([label-position=inline-start][label-alignment=end]) .ids-input .ids-label-text,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea label,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea .ids-label-text {
    justify-content: flex-start;
    text-align: start;
    align-self: start;
  }
}
@container (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input label,
  :host([label-position=inline-start][label-alignment=end]) .ids-input .ids-label-text,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea label,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea .ids-label-text {
    justify-content: flex-start;
    text-align: start;
    align-self: start;
  }
}
:host([label-position=inline-start][label-alignment=end]) .ids-input label.required::after,
:host([label-position=inline-start][label-alignment=end]) .ids-input .ids-label-text.required::after,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea label.required::after,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea .ids-label-text.required::after {
  margin-inline-end: 0;
  position: absolute;
  margin-top: unset;
  inset-inline-end: -5px;
  top: 7px;
}
@container (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input label.required::after,
  :host([label-position=inline-start][label-alignment=end]) .ids-input .ids-label-text.required::after,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea label.required::after,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea .ids-label-text.required::after {
    position: initial;
    margin-top: unset;
    inset-inline-end: initial;
  }
}
@media (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-input label.required::after,
  :host([label-position=inline-start][label-alignment=end]) .ids-input .ids-label-text.required::after,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea label.required::after,
  :host([label-position=inline-start][label-alignment=end]) .ids-textarea .ids-label-text.required::after {
    position: initial;
    margin-top: unset;
    inset-inline-end: initial;
  }
}
:host([label-position=inline-start][label-alignment=end]) .field-container {
  flex: 1;
}
:host([label-position=inline-start][label-alignment=end]) .ids-input.wrapped .validation-message,
:host([label-position=inline-start][label-alignment=end]) .ids-textarea.wrapped .validation-message {
  margin-inline-start: calc(var(--ids-label-width) + 14px);
}
:host([label-position=inline-start][label-alignment=end]) .ids-checkbox label {
  text-align: end;
}
@media (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-checkbox label {
    text-align: start;
  }
}
@container (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-checkbox label {
    text-align: start;
  }
}
:host([label-position=inline-start][label-alignment=end]) .ids-checkbox label.required .label-checkbox span::after {
  margin-inline-end: 0;
  position: absolute;
  margin-top: unset;
  right: -5px;
  top: -5px;
}
@media (width > 767px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-switch label {
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    text-align: end;
  }
  @container (width < 320px) {
    :host([label-position=inline-start][label-alignment=end]) .ids-switch label {
      justify-content: flex-start;
    }
  }
}
@media (width > 767px) and (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-switch label {
    justify-content: flex-start;
  }
}
:host([label-position=inline-start][label-alignment=end]) .ids-radio-group ids-text.group-label-text {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
}
@container (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-radio-group ids-text.group-label-text {
    justify-content: flex-start;
  }
}

:host([label-position=inline-start][label-alignment][label-state=collapsed]) .ids-input label,
:host([label-position=inline-start][label-alignment][label-state=collapsed]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-alignment][label-state=collapsed]) .ids-textarea label,
:host([label-position=inline-start][label-alignment][label-state=collapsed]) .ids-textarea .ids-label-text {
  display: none;
}

:host([label-position=inline-start][label-alignment=end][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input,
:host([label-position=inline-start][label-alignment=end][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea {
  column-gap: var(--ids-label-alignment-gap);
}

:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea {
  display: flex;
  flex-wrap: nowrap;
}
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input label,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea label,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input label,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea label {
  flex-shrink: 0;
}
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input .field-container,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea .field-container,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input .field-container,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
}
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-input .validation-message,
:host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-input .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count][error-tracker]) .ids-textarea .validation-message {
  width: auto;
  margin-inline-start: 0;
}

:host(.in-flex-item[label-position=inline-start]) .ids-input,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea {
  display: grid;
  gap: 0;
  grid-template-columns: auto minmax(0, 1fr);
  column-gap: var(--ids-label-alignment-gap);
}
:host(.in-flex-item[label-position=inline-start]) .ids-input label,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea label,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input label,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea label {
  grid-column: 1;
  grid-row: 1;
}
:host(.in-flex-item[label-position=inline-start]) .ids-input .field-container,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea .field-container,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input .field-container,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea .field-container {
  grid-column: 2;
  grid-row: 1;
  min-width: 0;
}
:host(.in-flex-item[label-position=inline-start]) .ids-input .validation-message,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea .validation-message {
  grid-column: 1/-1;
  grid-row: 2;
  width: auto;
  margin-inline-start: 0;
  margin-block-start: var(--ids-space-2xs);
}
:host(.in-flex-item[label-position=inline-start]) .ids-input.wrapped .validation-message,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea.wrapped .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input.wrapped .validation-message,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea.wrapped .validation-message {
  grid-column: 2;
  margin-inline-start: 0;
}
:host(.in-flex-item[label-position=inline-start]) .ids-input.sm, :host(.in-flex-item[label-position=inline-start]) .ids-input.mm, :host(.in-flex-item[label-position=inline-start]) .ids-input.md, :host(.in-flex-item[label-position=inline-start]) .ids-input.lg,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea.sm,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea.mm,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea.md,
:host(.in-flex-item[label-position=inline-start]) .ids-textarea.lg,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input.sm,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input.mm,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input.md,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-input.lg,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea.sm,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea.mm,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea.md,
:host([label-position=inline-start][label-break=shrink-value][validation-message-count]:not([error-tracker])) .ids-textarea.lg {
  grid-template-columns: auto minmax(0, 1fr);
}

:host(.in-flex-item[label-position=inline-start]) .ids-input label {
  max-height: var(--ids-label-max-height-inline-start);
}
:host(.in-flex-item[label-position=inline-start]) .ids-checkbox input[type=checkbox] ~ .checkmark {
  inset-inline-end: 0;
  margin-inline-end: 0;
}
:host(.in-flex-item[label-position=inline-start]) .ids-radio-group ids-text.group-label-text {
  margin-top: 0;
}

@media (width > 320px) {
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    flex-shrink: 0;
  }
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }
}
@container (width > 320px) {
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    flex-shrink: 0;
  }
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }
}
@media (width < 320px) {
  :host([label-position=inline-start][label-break=shrink-value]) .ids-input,
  :host([label-position=inline-start][label-break=shrink-value]) .ids-textarea {
    display: block;
  }
  :host([label-position=inline-start][label-break=shrink-value]) .ids-textarea {
    gap: 0;
  }
}
@container (width < 320px) {
  :host([label-position=inline-start][label-break=shrink-value]) .ids-input,
  :host([label-position=inline-start][label-break=shrink-value]) .ids-textarea,
  :host([label-position=inline-start][label-break=shrink-value]) .ids-radio-group {
    flex-wrap: wrap;
  }
}

@media (width <= 320px) {
  :host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea {
    display: block;
    gap: 0;
  }
  :host([label-position=inline-start][label-break=shrink-value]:not([validation-message-count])) .ids-textarea label {
    min-height: auto;
    margin-bottom: var(--ids-input-margin-bottom);
  }
}

@media (width > 320px) {
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    flex: 0 1 auto;
  }
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }
}
@container (width > 320px) {
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    flex: 0 1 auto;
  }
  :host([label-position=inline-start][label-break=shrink-label]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }
}

:host([label-position=inline-start][label-break=break]) .ids-input,
:host([label-position=inline-start][label-break=break]) .ids-textarea {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
:host([label-position=inline-start][label-break=break]) .ids-input label,
:host([label-position=inline-start][label-break=break]) .ids-textarea label {
  width: auto;
  flex-shrink: 0;
}
:host([label-position=inline-start][label-break=break]) .ids-input .field-container,
:host([label-position=inline-start][label-break=break]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
}
:host([label-position=inline-start][label-break=break]) .ids-input .validation-message,
:host([label-position=inline-start][label-break=break]) .ids-textarea .validation-message {
  width: auto;
  margin-inline-start: 0;
}

:host([label-position=inline-start][label-width="0px"]) .ids-label-text,
:host([label-position=inline-start][label-width="0"]) .ids-label-text {
  display: none;
}

:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-textarea .ids-label-text,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis]) .ids-textarea .ids-label-text {
  overflow: visible;
}
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-input .ids-label-text.required,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-textarea .ids-label-text.required,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis]) .ids-input .ids-label-text.required,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis]) .ids-textarea .ids-label-text.required {
  padding-inline-end: 0;
}
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-input .ids-label-text.required::after,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-textarea .ids-label-text.required::after,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis]) .ids-input .ids-label-text.required::after,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis]) .ids-textarea .ids-label-text.required::after {
  inset-inline-end: -7px;
}
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-input.wrapped .validation-message,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis-no-stretch]) .ids-textarea.wrapped .validation-message,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis]) .ids-input.wrapped .validation-message,
:host([label-position=inline-start][label-alignment=end][label-wrap=ellipsis]) .ids-textarea.wrapped .validation-message {
  margin-inline-start: calc(var(--ids-label-width) + 11px);
}

:host([label-position=inline-end][label-break=shrink-value]) .ids-input,
:host([label-position=inline-end][label-break=shrink-value]) .ids-textarea {
  display: flex;
}
:host([label-position=inline-end][label-break=shrink-value]) .ids-input label,
:host([label-position=inline-end][label-break=shrink-value]) .ids-textarea label {
  flex-shrink: 0;
  order: 2;
}
:host([label-position=inline-end][label-break=shrink-value]) .ids-input .field-container,
:host([label-position=inline-end][label-break=shrink-value]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
  order: 1;
}
:host([label-position=inline-end][label-break=shrink-value]) .ids-input {
  gap: var(--ids-space-2, 0.5rem);
}

@media (width > 320px) {
  :host([label-position=inline-end][label-break=shrink-label]) .ids-radio-group {
    display: flex;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-end][label-break=shrink-label]) .ids-radio-group ids-text.group-label-text {
    width: var(--ids-label-width);
    justify-content: end;
    flex: 0 1 auto;
    order: 2;
  }
  :host([label-position=inline-end][label-break=shrink-label]) .ids-radio-group slot {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    order: 1;
  }
}

:host([label-position=inline-end][label-break=break]) .ids-input,
:host([label-position=inline-end][label-break=break]) .ids-textarea {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
:host([label-position=inline-end][label-break=break]) .ids-input label,
:host([label-position=inline-end][label-break=break]) .ids-textarea label {
  width: auto;
  flex-shrink: 0;
  order: 2;
}
:host([label-position=inline-end][label-break=break]) .ids-input .field-container,
:host([label-position=inline-end][label-break=break]) .ids-textarea .field-container {
  min-width: 0;
  flex: 0 1 auto;
  order: 1;
}
:host([label-position=inline-end][label-break=break]) .ids-input .validation-message,
:host([label-position=inline-end][label-break=break]) .ids-textarea .validation-message {
  margin-inline-start: 0;
  order: 3;
}
:host([label-position=inline-end][label-break=break]) .ids-input {
  gap: var(--ids-space-2, 0.5rem);
}

:host([label-position=inline-start]) {
  --ids-label-width: var(--ids-label-width-inline-start);
}

:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-input label,
:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-textarea label,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-input label,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-textarea label {
  align-self: var(--ids-label-align-y, center);
}
:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-textarea .ids-label-text,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-input .ids-label-text,
:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-textarea .ids-label-text {
  overflow: visible;
}

@media (width > 767px) {
  :host([label-position=inline-start]:not([label-break=shrink-value]):not([size=full])) .ids-textarea {
    max-width: calc(370px + var(--ids-label-width));
  }
  :host([label-position=inline-start]:not([label-break=shrink-value]):not([size=full])) .ids-textarea .textarea-field {
    width: calc(370px + var(--ids-label-width));
  }
}
@media (width > 767px) {
  :host([label-position=inline-start]) .ids-filter-field {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start]) .ids-filter-field label {
    width: var(--ids-label-width);
    padding-block: var(--ids-label-padding-block);
    padding-inline-end: var(--ids-label-padding-inline-end);
    box-sizing: border-box;
  }
  :host([label-position=inline-start]) .ids-filter-field #operator-button {
    position: relative;
    inset-inline-start: var(--ids-label-width);
  }
  :host([label-position=inline-start]) .ids-filter-field .validation-message {
    width: 100%;
    margin-block-start: var(--ids-space-2xs);
  }
}
@media (width < 767px) {
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox label {
    --ids-checkbox-padding-inline-start: inherit;
  }
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox .validation-message {
    margin-inline-start: initial;
  }
}

@media (min-width: 767px) {
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox input[type=checkbox] ~ .checkmark {
    right: initial;
  }
  :host([label-position=inline-start][dir=rtl]) .ids-checkbox .validation-message {
    margin-block-start: 0;
  }
}
:host([label-position=inline-start]) .ids-radio-group.label-inline,
:host([label-position=inline-end]) .ids-radio-group.label-inline {
  display: flex;
  align-items: var(--ids-label-align-y, flex-start);
  gap: var(--ids-space-2, 0.5rem);
}
:host([label-position=inline-start]) .ids-radio-group.label-inline ids-text.group-label-text,
:host([label-position=inline-end]) .ids-radio-group.label-inline ids-text.group-label-text {
  min-width: var(--ids-label-width);
  margin-top: calc(var(--ids-space-xs) - 2px);
}
:host([label-position=inline-start]) .ids-radio-group.label-inline slot,
:host([label-position=inline-end]) .ids-radio-group.label-inline slot {
  display: flex;
  flex-direction: column;
}

:host([label-position=inline-end]) .ids-radio-group.label-inline ids-text.group-label-text {
  justify-content: end;
  order: 2;
}
:host([label-position=inline-end]) .ids-radio-group.label-inline slot {
  order: 1;
}

:host([label-position=inline-end]) .ids-radio-group.label-inline-end-stacked {
  display: flex;
  align-items: var(--ids-label-align-y, baseline);
  gap: var(--ids-space-2, 0.5rem);
  flex-direction: column;
}
:host([label-position=inline-end]) .ids-radio-group.label-inline-end-stacked ids-text.group-label-text {
  min-width: var(--ids-label-width);
  order: 2;
}
:host([label-position=inline-end]) .ids-radio-group.label-inline-end-stacked slot {
  display: flex;
  flex-direction: column;
  order: 1;
}

@media (width > 767px) {
  :host([label-position=inline-start]) .ids-switch {
    display: flex;
    flex-wrap: wrap;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start]) .ids-switch label {
    width: var(--ids-label-width);
    padding-block: var(--ids-label-padding-block);
    padding-inline-end: var(--ids-label-padding-inline-end);
    padding-inline-start: 0;
    box-sizing: border-box;
  }
  :host([label-position=inline-start]) .ids-switch input[type=checkbox] ~ .slider {
    left: unset;
    right: -45px;
  }
  :host([label-position=inline-start][label-state=collapsed]) .ids-switch label {
    padding-inline-end: 0;
    width: 0;
  }
  :host([label-position=inline-start][dir=rtl]) .ids-switch input[type=checkbox] ~ .slider {
    left: -45px;
    right: initial;
  }
}
@media (width > 767px) {
  :host([label-position=inline-start]) .ids-data-label {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: var(--ids-label-align-y, baseline);
  }
  :host([label-position=inline-start]) .ids-data-label .label {
    width: var(--ids-label-width);
    padding-block: var(--ids-label-padding-block);
    box-sizing: border-box;
    margin-block-end: 0;
    white-space: nowrap;
  }
  :host([label-position=inline-start]) .ids-data-label .data,
  :host([label-position=inline-start]) .ids-data-label .description {
    display: flex;
    padding-block: var(--ids-label-padding-block);
  }
}
@media (max-width: 320px) {
  :host([label-position=inline-start]) .ids-input,
  :host([label-position=inline-start]) .ids-textarea,
  :host([label-position=inline-start]) .ids-filter-field {
    display: flex;
    flex-direction: column;
    align-items: unset;
  }
  :host([label-position=inline-start]) .ids-input label,
  :host([label-position=inline-start]) .ids-textarea label,
  :host([label-position=inline-start]) .ids-filter-field label {
    width: auto;
    text-align: start;
    padding-inline: 0;
  }
  :host([label-position=inline-start]) .ids-input .validation-message,
  :host([label-position=inline-start]) .ids-textarea .validation-message,
  :host([label-position=inline-start]) .ids-filter-field .validation-message {
    margin-inline-start: 0;
  }
  :host([label-position=inline-end]) .ids-input,
  :host([label-position=inline-end]) .ids-textarea,
  :host([label-position=inline-end]) .ids-filter-field {
    display: flex;
    flex-direction: column;
    align-items: unset;
    gap: var(--ids-space-2, 0.5rem);
  }
  :host([label-position=inline-end]) .ids-input label,
  :host([label-position=inline-end]) .ids-textarea label,
  :host([label-position=inline-end]) .ids-filter-field label {
    width: auto;
    text-align: start;
    padding-inline: 0;
  }
  :host([label-position=inline-end]) .ids-input .validation-message,
  :host([label-position=inline-end]) .ids-textarea .validation-message,
  :host([label-position=inline-end]) .ids-filter-field .validation-message {
    margin-inline-start: 0;
  }
}
:host([label-state=collapsed]) {
  --ids-label-width: 0;
  width: fit-content;
}

:host(ids-checkbox[label-state=collapsed]) {
  width: fit-content;
  display: block;
}

@container (max-width: 320px) {
  :host([label-position=inline-start]) .ids-input,
  :host([label-position=inline-start]) .ids-textarea,
  :host([label-position=inline-start]) .ids-filter-field {
    display: flex;
    flex-direction: column;
    align-items: unset;
  }
  :host([label-position=inline-start]) .ids-input label,
  :host([label-position=inline-start]) .ids-textarea label,
  :host([label-position=inline-start]) .ids-filter-field label {
    width: auto;
    text-align: start;
    padding-inline: 0;
  }
  :host([label-position=inline-start]) .ids-input .validation-message,
  :host([label-position=inline-start]) .ids-textarea .validation-message,
  :host([label-position=inline-start]) .ids-filter-field .validation-message {
    margin-inline-start: 0;
  }
  :host([label-position=inline-end]) .ids-input,
  :host([label-position=inline-end]) .ids-textarea,
  :host([label-position=inline-end]) .ids-filter-field {
    display: flex;
    flex-direction: column;
    align-items: unset;
    gap: var(--ids-space-2, 0.5rem);
  }
  :host([label-position=inline-end]) .ids-input label,
  :host([label-position=inline-end]) .ids-textarea label,
  :host([label-position=inline-end]) .ids-filter-field label {
    width: auto;
    text-align: start;
    padding-inline: 0;
  }
  :host([label-position=inline-end]) .ids-input .validation-message,
  :host([label-position=inline-end]) .ids-textarea .validation-message,
  :host([label-position=inline-end]) .ids-filter-field .validation-message {
    margin-inline-start: 0;
  }
}
@media (max-width: 320px) {
  :host([label-position=inline-start][label-state=hidden]) .ids-input .ids-label-text {
    display: none;
  }
}

@container (max-width: 320px) {
  :host([label-position=inline-start][label-state=hidden]) .ids-input .ids-label-text {
    display: none;
  }
}
:host .ids-input label,
:host .ids-input .label,
:host .ids-textarea label,
:host .ids-textarea .label,
:host .ids-checkbox label,
:host .ids-checkbox .label,
:host .ids-radio label,
:host .ids-radio .label,
:host .ids-switch label,
:host .ids-switch .label,
:host .ids-data-label label,
:host .ids-data-label .label,
:host .ids-filter-field label,
:host .ids-filter-field .label {
  width: var(--ids-label-width);
}

:host([label-position=inline-start][label-state=collapsed]) .ids-radio-group ids-text.group-label-text,
:host([label-position=inline-end][label-state=collapsed]) .ids-radio-group ids-text.group-label-text {
  display: none;
}

:host([label-position=inline-start][label-state=hidden]) .ids-radio-group ids-text.group-label-text,
:host([label-position=inline-end][label-state=hidden]) .ids-radio-group ids-text.group-label-text {
  visibility: hidden;
}

:host([hidden]) {
  display: none;
}

:host(.justify-center) .ids-checkbox .checkmark,
:host(.justify-center) .ids-checkbox:not([color]) input[type=checkbox] ~ .checkmark {
  top: calc(50% - 8px);
}

:host([no-margins]) .ids-checkbox,
:host([no-margin]) .ids-checkbox {
  margin: var(--ids-space-none);
}
:host([no-margins]) .ids-checkbox label.empty,
:host([no-margin]) .ids-checkbox label.empty {
  position: relative;
  top: 4px;
}

:host([margin-block-end=none]:not([no-margins])) .ids-checkbox,
.ids-checkbox.margin-block-end-none:not(.no-margins) {
  margin-block-end: var(--ids-space-none);
}

:host([margin-block-end="4xs"]:not([no-margins])) .ids-checkbox,
.ids-checkbox.margin-block-end-4xs:not(.no-margins) {
  margin-block-end: var(--ids-space-4xs);
}

:host([margin-block-end="3xs"]:not([no-margins])) .ids-checkbox,
.ids-checkbox.margin-block-end-3xs:not(.no-margins) {
  margin-block-end: var(--ids-space-3xs);
}

:host([margin-block-end="2xs"]:not([no-margins])) .ids-checkbox,
.ids-checkbox.margin-block-end-2xs:not(.no-margins) {
  margin-block-end: var(--ids-space-2xs);
}

:host([margin-block-end=xs]:not([no-margins])) .ids-checkbox,
.ids-checkbox.margin-block-end-xs:not(.no-margins) {
  margin-block-end: var(--ids-space-xs);
}

:host([margin-block-end=sm]:not([no-margins])) .ids-checkbox,
.ids-checkbox.margin-block-end-sm:not(.no-margins) {
  margin-block-end: var(--ids-space-sm);
}

:host([margin-block-end=md]:not([no-margins])) .ids-checkbox,
.ids-checkbox.margin-block-end-md:not(.no-margins) {
  margin-block-end: var(--ids-space-md);
}

:host([margin-block-end=lg]:not([no-margins])) .ids-checkbox,
.ids-checkbox.margin-block-end-lg:not(.no-margins) {
  margin-block-end: var(--ids-space-lg);
}

:host([margin-block-end=xl]:not([no-margins])) .ids-checkbox,
.ids-checkbox.margin-block-end-xl:not(.no-margins) {
  margin-block-end: var(--ids-space-xl);
}

:host([margin-block-end="2xl"]:not([no-margins])) .ids-checkbox,
.ids-checkbox.margin-block-end-2xl:not(.no-margins) {
  margin-block-end: var(--ids-space-2xl);
}

:host([margin-block-end="3xl"]:not([no-margins])) .ids-checkbox,
.ids-checkbox.margin-block-end-3xl:not(.no-margins) {
  margin-block-end: var(--ids-space-3xl);
}

:host([margin-block-end="4xl"]:not([no-margins])) .ids-checkbox,
.ids-checkbox.margin-block-end-4xl:not(.no-margins) {
  margin-block-end: var(--ids-space-4xl);
}

:host(.event-type-checkbox) .ids-checkbox .ids-label-text {
  max-width: 150px;
}

.ids-checkbox {
  margin-bottom: var(--ids-checkbox-margin-bottom);
  pointer-events: none;
}
.ids-checkbox label {
  cursor: normal;
  pointer-events: none;
  user-select: none;
  padding-inline-start: var(--ids-checkbox-padding-inline-start);
  margin-inline-end: var(--ids-checkbox-margin-inline-end);
  position: relative;
  inset-inline-start: 0;
  display: block;
}
.ids-checkbox label.empty::before {
  content: " ";
}
.ids-checkbox label.required .label-checkbox span::after {
  position: relative;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-size: var(--ids-font-size-md);
  color: var(--ids-input-required-indicator-color-text-default);
  content: "*";
  margin-inline-start: 1px;
  top: -4px;
  vertical-align: text-top;
}
.ids-checkbox label.no-required-indicator .label-checkbox span::after, .ids-checkbox label.empty .label-checkbox span::after {
  content: "";
}
.ids-checkbox label.no-required-indicator, .ids-checkbox label.empty {
  min-height: 20px;
}
.ids-checkbox .label-checkbox {
  cursor: var(--ids-cursor-pointer);
  pointer-events: none;
  position: relative;
  inset-inline-start: var(--ids-checkbox-label-inset-inline-start, 0);
  top: var(--ids-checkbox-label-top, 1px);
}
.ids-checkbox .label-checkbox span {
  pointer-events: auto;
  white-space: normal;
}
.ids-checkbox.label-align-start {
  text-align: start;
}
.ids-checkbox.label-align-end {
  text-align: end;
}
.ids-checkbox.label-align-center {
  text-align: center;
}
.ids-checkbox.label-align-justify {
  text-align: justify;
}
.ids-checkbox.disabled label {
  cursor: var(--ids-cursor-default);
  opacity: var(--ids-checkbox-opacity-disabled);
}
.ids-checkbox.disabled label.required .label-checkbox span::after {
  color: var(--ids-input-required-indicator-color-text-disabled);
}
.ids-checkbox.hitbox {
  padding-top: var(--ids-space-12);
  padding-bottom: var(--ids-space-12);
}
.ids-checkbox.hitbox label {
  padding-inline-start: 42px;
}
.ids-checkbox.hitbox label span.checkmark {
  margin-inline-start: 14px;
}
.ids-checkbox.hitbox .validation-message {
  margin-inline-start: 14px;
}
.ids-checkbox.horizontal {
  margin-inline-end: var(--ids-space-12);
  display: inline-block;
}
.ids-checkbox input[type=checkbox] {
  position: absolute;
  cursor: var(--ids-cursor-pointer);
  opacity: 0;
  height: 0;
  width: 0;
}
.ids-checkbox input[type=checkbox] ~ .checkmark {
  position: absolute;
  border: var(--ids-checkbox-border);
  border-radius: var(--ids-checkbox-border-radius);
  height: 14px;
  width: 14px;
  left: 0;
  top: 3px;
  cursor: var(--ids-cursor-pointer);
  pointer-events: auto;
}
.ids-checkbox input[type=checkbox].error ~ .checkmark {
  border-color: var(--ids-checkbox-color-border-error);
}
.ids-checkbox input[type=checkbox]:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected);
  border-color: var(--ids-checkbox-color-border-selected);
}
.ids-checkbox input[type=checkbox]:checked ~ .checkmark::after {
  position: absolute;
  display: block;
  border: var(--ids-font-size-2xs) solid var(--ids-checkbox-color-border-selected-after);
  border-width: var(--ids-checkbox-border-width-selected-after);
  animation: check 0.15s ease-out;
  transform: rotate(45deg);
  content: "";
  height: 10px;
  left: 4px;
  top: 0;
  width: 4px;
}
.ids-checkbox input[type=checkbox].indeterminate ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-indeterminate);
  border-color: var(--ids-checkbox-color-border-indeterminate);
}
.ids-checkbox input[type=checkbox].indeterminate ~ .checkmark::after {
  position: absolute;
  animation: checkindeterminate 0.15s ease-out;
  display: block;
  border: 1px solid var(--ids-checkbox-color-border-indeterminate-after);
  border-width: var(--ids-checkbox-border-width-indeterminate);
  content: "";
  height: 6px;
  left: 2px;
  top: 0;
  transform: none;
  width: 10px;
}
.ids-checkbox input[type=checkbox]:focus ~ .checkmark {
  border-color: var(--ids-checkbox-color-border-focus);
  box-shadow: var(--ids-checkbox-shadow-focus);
}
.ids-checkbox input[type=checkbox]:focus.error ~ .checkmark {
  border-color: var(--ids-checkbox-color-border-focus-error);
  box-shadow: var(--ids-checkbox-shadow-focus-error);
}
.ids-checkbox input[type=checkbox]:disabled ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-disabled);
  border-color: var(--ids-checkbox-color-border-disabled);
  cursor: var(--ids-cursor-default);
}
.ids-checkbox input[type=checkbox]:disabled ~ .label-checkbox {
  cursor: var(--ids-cursor-default);
  color: var(--ids-checkbox-color-text-disabled);
}
.ids-checkbox input[type=checkbox]:disabled.error ~ .checkmark {
  border-color: var(--ids-checkbox-color-border-focus-error);
}
.ids-checkbox input[type=checkbox]:disabled:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected-disabled);
  border-color: var(--ids-checkbox-color-border-selected-disabled);
}
.ids-checkbox.no-animation input[type=checkbox]:checked ~ .checkmark::after {
  animation: none;
}
.ids-checkbox[color=green] input[type=checkbox] ~ .checkmark {
  background-color: var(--ids-color-green-70);
  border-color: var(--ids-color-green-70);
}
.ids-checkbox[color=green] input[type=checkbox]:disabled ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-disabled);
  border-color: var(--ids-checkbox-color-border-disabled);
  cursor: var(--ids-cursor-default);
}
.ids-checkbox[color=green] input[type=checkbox]:disabled:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected-disabled);
  border-color: var(--ids-checkbox-color-border-selected-disabled);
}
.ids-checkbox[color=green] input[type=checkbox]:focus ~ .checkmark {
  border-color: var(--ids-color-green-70);
}
.ids-checkbox[color=purple] input[type=checkbox] ~ .checkmark {
  background-color: var(--ids-color-purple-70);
  border-color: var(--ids-color-purple-70);
}
.ids-checkbox[color=purple] input[type=checkbox]:disabled ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-disabled);
  border-color: var(--ids-checkbox-color-border-disabled);
  cursor: var(--ids-cursor-default);
}
.ids-checkbox[color=purple] input[type=checkbox]:disabled:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected-disabled);
  border-color: var(--ids-checkbox-color-border-selected-disabled);
}
.ids-checkbox[color=purple] input[type=checkbox]:focus ~ .checkmark {
  border-color: var(--ids-color-purple-70);
}
.ids-checkbox[color=blue] input[type=checkbox] ~ .checkmark {
  background-color: var(--ids-color-blue-70);
  border-color: var(--ids-color-blue-70);
}
.ids-checkbox[color=blue] input[type=checkbox]:disabled ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-disabled);
  border-color: var(--ids-checkbox-color-border-disabled);
  cursor: var(--ids-cursor-default);
}
.ids-checkbox[color=blue] input[type=checkbox]:disabled:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected-disabled);
  border-color: var(--ids-checkbox-color-border-selected-disabled);
}
.ids-checkbox[color=blue] input[type=checkbox]:focus ~ .checkmark {
  border-color: var(--ids-color-blue-70);
}
.ids-checkbox[color=orange] input[type=checkbox] ~ .checkmark {
  background-color: var(--ids-color-orange-70);
  border-color: var(--ids-color-orange-70);
}
.ids-checkbox[color=orange] input[type=checkbox]:disabled ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-disabled);
  border-color: var(--ids-checkbox-color-border-disabled);
  cursor: var(--ids-cursor-default);
}
.ids-checkbox[color=orange] input[type=checkbox]:disabled:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected-disabled);
  border-color: var(--ids-checkbox-color-border-selected-disabled);
}
.ids-checkbox[color=orange] input[type=checkbox]:focus ~ .checkmark {
  border-color: var(--ids-color-orange-70);
}
.ids-checkbox[color=red] input[type=checkbox] ~ .checkmark {
  background-color: var(--ids-color-red-70);
  border-color: var(--ids-color-red-70);
}
.ids-checkbox[color=red] input[type=checkbox]:disabled ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-disabled);
  border-color: var(--ids-checkbox-color-border-disabled);
  cursor: var(--ids-cursor-default);
}
.ids-checkbox[color=red] input[type=checkbox]:disabled:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected-disabled);
  border-color: var(--ids-checkbox-color-border-selected-disabled);
}
.ids-checkbox[color=red] input[type=checkbox]:focus ~ .checkmark {
  border-color: var(--ids-color-red-70);
}
.ids-checkbox .validation-message {
  margin-top: var(--ids-space-2xs);
  margin-inline-start: -1px;
}
.ids-checkbox.has-focus input[type=checkbox] ~ .checkmark {
  border-color: var(--ids-checkbox-focus-border-color);
  box-shadow: var(--ids-checkbox-focus-box-shadow);
}

:host(.in-flex-item) .ids-checkbox {
  align-content: center;
  min-height: var(--ids-checkbox-inline-min-height, auto);
  margin-bottom: 0;
}
@media (width < 320px) {
  :host(.in-flex-item) .ids-checkbox {
    margin-top: auto;
  }
}

@media (width < 320px) {
  :host([label-position=inline-start]) .ids-checkbox label {
    display: block;
    padding-inline-start: var(--ids-checkbox-padding-inline-start);
  }
  :host([label-position=inline-start]) .ids-checkbox .label-checkbox {
    width: auto;
    display: inline;
    order: 2;
  }
  :host([label-position=inline-start]) .ids-checkbox .checkbox-wrapper {
    display: contents;
    order: 1;
  }
  :host([label-position=inline-start]) .ids-checkbox .checkbox-wrapper .checkmark {
    position: absolute;
    inset-inline-start: 0;
    top: 3px;
  }
}
@container (width < 320px) {
  :host([label-position=inline-start]) .ids-checkbox label {
    display: block;
    padding-inline-start: var(--ids-checkbox-padding-inline-start);
  }
  :host([label-position=inline-start]) .ids-checkbox .label-checkbox {
    width: auto;
    display: inline;
    order: 2;
  }
  :host([label-position=inline-start]) .ids-checkbox .checkbox-wrapper {
    display: contents;
    order: 1;
  }
  :host([label-position=inline-start]) .ids-checkbox .checkbox-wrapper .checkmark {
    position: absolute;
    inset-inline-start: 0;
    top: 3px;
  }
}
:host([label-position=inline-start]) .ids-checkbox label {
  display: flex;
  align-items: center;
  gap: var(--ids-space-xs);
  padding-inline-start: 0;
}
:host([label-position=inline-start]) .ids-checkbox .label-checkbox {
  width: var(--ids-label-width, auto);
  flex-shrink: 0;
  display: flex;
  align-items: center;
}
:host([label-position=inline-start]) .ids-checkbox .checkbox-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
:host([label-position=inline-start]) .ids-checkbox .checkbox-wrapper input[type=checkbox] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
:host([label-position=inline-start]) .ids-checkbox .checkbox-wrapper .checkmark {
  position: absolute;
  border: var(--ids-checkbox-border);
  border-radius: var(--ids-checkbox-border-radius);
  height: 14px;
  width: 14px;
  left: 0;
  top: 3px;
  position: relative;
  top: 0;
  inset-inline-start: 0;
  inset-inline-end: unset;
}
:host([label-position=inline-start]) .ids-checkbox .checkbox-wrapper input[type=checkbox]:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected);
  border-color: var(--ids-checkbox-color-border-selected);
}
:host([label-position=inline-start]) .ids-checkbox .checkbox-wrapper input[type=checkbox]:checked ~ .checkmark::after {
  position: absolute;
  display: block;
  border: var(--ids-font-size-2xs) solid var(--ids-checkbox-color-border-selected-after);
  border-width: var(--ids-checkbox-border-width-selected-after);
  animation: check 0.15s ease-out;
  transform: rotate(45deg);
  content: "";
  height: 10px;
  left: 4px;
  top: 0;
  width: 4px;
}
:host([label-position=inline-start]) .ids-checkbox .checkbox-wrapper input[type=checkbox].indeterminate ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-indeterminate);
  border-color: var(--ids-checkbox-color-border-indeterminate);
}
:host([label-position=inline-start]) .ids-checkbox .checkbox-wrapper input[type=checkbox].indeterminate ~ .checkmark::after {
  position: absolute;
  animation: checkindeterminate 0.15s ease-out;
  display: block;
  border: 1px solid var(--ids-checkbox-color-border-indeterminate-after);
  border-width: var(--ids-checkbox-border-width-indeterminate);
  content: "";
  height: 6px;
  left: 2px;
  top: 0;
  transform: none;
  width: 10px;
}
:host([label-position=inline-start]) .ids-checkbox .checkbox-wrapper input[type=checkbox]:focus ~ .checkmark {
  border-color: var(--ids-checkbox-color-border-focus);
  box-shadow: var(--ids-checkbox-shadow-focus);
}
:host([label-position=inline-start]) .ids-checkbox .checkbox-wrapper input[type=checkbox]:focus.error ~ .checkmark {
  border-color: var(--ids-checkbox-color-border-focus-error);
  box-shadow: var(--ids-checkbox-shadow-focus-error);
}
:host([label-position=inline-start]) .ids-checkbox .checkbox-wrapper input[type=checkbox]:disabled ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-disabled);
  border-color: var(--ids-checkbox-color-border-disabled);
  cursor: var(--ids-cursor-default);
}
:host([label-position=inline-start]) .ids-checkbox .checkbox-wrapper input[type=checkbox]:disabled:checked ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-selected-disabled);
  border-color: var(--ids-checkbox-color-border-selected-disabled);
}
:host([label-position=inline-start]) .ids-checkbox.label-state-collapsed label {
  gap: unset;
}
:host([label-position=inline-start]) .ids-checkbox.label-state-collapsed label::before {
  display: none;
}
:host([label-position=inline-start]) .ids-checkbox.label-state-collapsed label ids-text {
  display: none;
}
:host([label-position=inline-start]) .ids-checkbox.label-state-hidden label::before {
  display: none;
}

:host([label-position=inline-start][label-alignment=end]) .ids-checkbox .label-checkbox {
  justify-content: flex-end;
  text-align: end;
  top: unset;
}
@media (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-checkbox .label-checkbox {
    justify-content: flex-start;
    text-align: start;
  }
}
@container (width < 320px) {
  :host([label-position=inline-start][label-alignment=end]) .ids-checkbox .label-checkbox {
    justify-content: flex-start;
    text-align: start;
  }
}

:host([dir=rtl]) input[type=checkbox] ~ .checkmark {
  left: initial;
  right: 0;
}

:host(.multiselect-checkbox.ellipsis) .ids-checkbox label {
  padding-inline-start: var(--ids-space-sm);
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: top;
  display: flex;
}
:host(.multiselect-checkbox.ellipsis) .ids-checkbox label .label-checkbox {
  min-width: 0;
}
:host(.multiselect-checkbox.ellipsis) .ids-checkbox label .label-checkbox span {
  white-space: unset;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}
:host(.multiselect-checkbox.ellipsis) .ids-checkbox label ids-text::part(text),
:host(.multiselect-checkbox.ellipsis) .ids-checkbox label .ids-text {
  display: unset;
  position: relative;
  top: -1px;
}

:host(.multiselect-checkbox.ellipsis[size=full]) .ids-checkbox label {
  display: flex;
  max-width: 100%;
}
:host(.multiselect-checkbox.ellipsis[size=full]) .ids-checkbox label .label-checkbox span {
  white-space: nowrap;
}

:host(.multiselect-loaded) .ids-checkbox {
  text-indent: 0;
  position: relative;
  top: -5px;
}
:host(.multiselect-loaded) .ids-checkbox label {
  margin-inline-end: 0;
  padding-inline-start: var(--ids-space-sm);
}

:host(.multiselect-checkbox) input[type=checkbox]:not(:checked):not(:disabled) ~ .checkmark {
  background-color: var(--ids-checkbox-color-background-multiselect);
  top: 2px;
}
:host(.multiselect-checkbox) {
  margin-top: auto;
  margin-bottom: auto;
}
:host(.multiselect-checkbox) .ids-checkbox ids-text {
  top: 2px;
}
:host(.multiselect-checkbox) .ids-checkbox ids-text:not(.empty) {
  inset-inline-start: 4px;
}

:host([label-wrap=ellipsis]) .ids-checkbox .label-checkbox {
  display: block;
  width: var(--ids-label-width, 100%);
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host([label-wrap=ellipsis]) .ids-checkbox .label-checkbox span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host([label-wrap=ellipsis-no-stretch]) .ids-checkbox .label-checkbox {
  display: block;
  width: var(--ids-label-width, 100%);
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host([label-wrap=ellipsis-no-stretch]) .ids-checkbox .label-checkbox span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host([label-wrap=ellipsis-no-stretch]) .ids-checkbox .label-checkbox {
  max-width: 75%;
}
:host([label-wrap=ellipsis-no-stretch]) .ids-checkbox.label-align-end .label-checkbox {
  margin-inline-start: auto;
}
:host([label-wrap=ellipsis-no-stretch]) .ids-checkbox.label-align-center .label-checkbox {
  margin-inline: auto;
}

:host([label-wrap=wrap-no-stretch]) .ids-checkbox .label-checkbox {
  max-width: 75%;
}

:host([label-position=inline-start][label-wrap=wrap-no-stretch]) .ids-checkbox .label-checkbox,
:host([label-position=inline-start][label-wrap=ellipsis-no-stretch]) .ids-checkbox .label-checkbox {
  max-width: none;
}

@media (width > 320px) {
  :host([start-label-width]:not([label-position=inline-start])) .ids-checkbox {
    padding-inline-start: calc(var(--ids-start-label-width) + var(--ids-label-padding-inline-end));
  }
}
@container (max-width: 320px) {
  :host([start-label-width]:not([label-position=inline-start])) .ids-checkbox {
    padding-inline-start: 0;
  }
}

.ids-checkbox .ids-label-text {
  padding-inline-end: var(--ids-checkbox-label-padding-inline-end, 0);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
